import ContentColumn from './ContentColumn';

export default ContentColumn;
